"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.PillContainer = exports.StyledLink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../Typography"));
exports.StyledLink = styled_components_1.default.a `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: inherit;
  text-decoration: none;
`;
exports.PillContainer = styled_components_1.default.div `
  width: ${props => props.width && props.width}px;
  cursor: pointer;

  ${props => props.isActive
    ? `
    padding: ${props.theme.spacing.s2}px ${props.theme.spacing.s3}px;
    background-color: ${props.theme.palette.ORANGE_100};
    border-radius: ${props.theme.attributes.borderRadius.xs}px;
  `
    : `
    margin: ${props.theme.spacing.s2}px 0;
  `}
`;
exports.Label = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => (props.isActive ? props.theme.palette.BW_100 : props.theme.palette.BLUE_100)};
`;
exports.default = {
    PillContainer: exports.PillContainer,
    Label: exports.Label
};
